import { render, staticRenderFns } from "./AddUpdateDialog.vue?vue&type=template&id=778f9e1e&scoped=true&"
import script from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
import style1 from "./AddUpdateDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f9e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778f9e1e')) {
      api.createRecord('778f9e1e', component.options)
    } else {
      api.reload('778f9e1e', component.options)
    }
    module.hot.accept("./AddUpdateDialog.vue?vue&type=template&id=778f9e1e&scoped=true&", function () {
      api.rerender('778f9e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logoConfig/components/AddUpdateDialog.vue"
export default component.exports